'use client';

import { createContext, PropsWithChildren, useContext, useMemo } from 'react';

interface NetworkContextData {
  network: AdaptedNetwork;
}

const NetworkContext = createContext({} as NetworkContextData);

interface Props extends PropsWithChildren {
  network: AdaptedNetwork;
}

export type NetworkContextProviderProps = Props;

export const NetworkContextProvider = (props: Props) => {
  const { network, children } = props;

  const value = useMemo(() => {
    return { network };
  }, [network]);

  return (
    <NetworkContext.Provider value={value}>{children}</NetworkContext.Provider>
  );
};

export const useNetwork = () => useContext(NetworkContext);
